import { makeAutoObservable, runInAction } from "mobx";
import { Store, IReportStore, AnalyticsData } from "../global/types";
import { getReportAnalyticsData, getReportMatricsData } from "../api/user.action";
  
class ReportStore implements IReportStore {
    rootStore: Store;
    analyticsData: AnalyticsData | null = null
    reportMetricsData: AnalyticsData[] = []
    error: string | null = null;
    loading: boolean = false;
    leagueFilter: number = 1;

    constructor(rootStore: Store) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setLoading = (loading: boolean) => {
        this.loading = loading;
    }

    fetchReportAnalyticsData = async(startDate?: Date, endDate?: Date) => {
        this.setLoading(true);
        try {
            const response = await getReportAnalyticsData(startDate, endDate)
            runInAction(() => {
               this.analyticsData = response.data
            })
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error)
        } finally {
            this.setLoading(false)
        }
    }

    fetchReportMetricsData = async(startDate?: Date, endDate?: Date, compareStart?: Date, compareEnd?: Date) => {
        this.setLoading(true);
        try {
            const response = await getReportMatricsData(startDate, endDate, compareStart, compareEnd)
            runInAction(() => {
               this.reportMetricsData = response.data
            })
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error)
        } finally {
            this.setLoading(false)
        }
    }

    resetReportData = () => {
        runInAction(() => {
            this.error = null;
            this.analyticsData = null;
            this.reportMetricsData = [];
            this.loading = false;
        })
    }
}

export default ReportStore;
